<template>
  <div class="leaderDetail">
    <heads></heads>
    <div class="top-img">
      <img src="../../../static/images/banner02.jpg" alt="">
    </div>
    <div class="container">
      <div class="content" v-loading="loading">
        <div class="leaderlist">
          <div class="leaderitem">
            <img :src="page.headPicPath" class="left-img" />
            <div class="right-info">
              <div class="name">
                {{page.name}}
                <i :class="['fa',page.gender === 'female' ?  'fa-venus' : 'fa-mars'] " aria-hidden="true"></i>
              </div>
              <div class="evaluate">
                <span>带队 {{total}}次</span>
                <!-- <span>评分 4.9</span> -->
              </div>
            </div>
          </div>
          <div class="textnav">
            <div
          v-for="(item,index) in navArray"
          :key="index"
          class="textnav-item"
          :class="nav === index?'nac-active':''"
          @click="getNav(index)"
        >   
        <span>{{item}}</span>
        <span v-if="index === 2 && evaluateTotal" class="total">{{evaluateTotal}}</span>
      </div>
          </div>
          <div class="useractivity" v-if="nav==0">
            <div class="useritem" v-for="(item,index) in pageArray" :key="index" @click="toDetail(item.lineSchedule.line.id)">
              <div class="img">
                <img :src="item.linePictureUrl" class="act-img" />
                <span class="user-price">￥{{item.price}}</span>
              </div>
              <div class="user-right">
                <div class="act-title">{{item.lineSchedule.line.lineTitile}}</div>
                <p class="userdescribe">{{item.lineSchedule.line.lineAbstract}}</p>
                <div class="bottom-infos">
                  <div>
                    <!-- <span class="icon-one">
                      <i class="fa fa-eye" aria-hidden="true"></i> 1265
                    </span> -->
                    <span class="icon-two">
                      <i class="fa fa-clock-o" aria-hidden="true"></i> {{fomateDate(item.lineSchedule.departDate)}}
                    </span>
                  </div>
                  <!-- <span class="mores">
                    查看更多
                    <i class="fa fa-arrow-right" aria-hidden="true"></i>
                  </span> -->
                </div>
              </div>
            </div>
             <div class="pagination">
              <el-pagination
                background
                layout="prev, pager, next"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="pageNumber"
                :page-size="10"
                :total="total"
              ></el-pagination>
            </div>
          </div>
          <div class="evaluate-content" v-else-if="nav==2">
              <total-comment :score="page.score" :evaluteCount="page.evaluateCount" 
              :twoStarCount="page.twoStarCount"
              :oneStarCount="page.oneStarCount"
              :threeStarCount="page.threeStarCount"
              :fourStarCount="page.fourStarCount"
              :fiveStarCount="page.fiveStarCount"
              ></total-comment>
              <div class="evaluate-list">
                <div class="art-title">最新评价</div>
                <ul>
                <li class="evaluate-item" v-for="(item, index) in evaluateList" :key="index">
                  <div class="evaluate-main">
                  <div class="left">
                    <div class="avatar">
                      <img :src="item.headPicPath" />
                    </div>
                    <span class="name">{{item.username}}</span>
                  </div>
                  <div class="right">
                    <div class="text ">{{ item.comment }}</div>
                    <div class="comment-images-out">
                      <image-preview-list v-if="item.image" :height="70" :width="70" :picList="item.image" />
                      <!-- <div class="comment-images"  v-show="item.image" >
                        <img v-for="(image2,index2) in item.image" :key="index2" alt="" :src="image2" @click="previewImage(index2,item.image)"/>
                      </div> -->
                    </div> 
                    <div class="star-wrapper">
                        <el-rate
                          v-model="item.leaderScore"
                          disabled
                          :colors="['#FF7E00', '#FF7E00', '#FF7E00']"
                          >
                      </el-rate>
                    </div>
                    <div class="bottom-line">
                      <span class="time">{{fomateDate2(item.departDate)}}出发</span>
                      <span class="leader">{{item.lineTitle}}</span>
                    </div>
                  </div>
                </div>
                  <div
                    class="seller-reply"
                    v-if="item.evaluateReply"
                  >官方回复:<span class="main"> {{item.evaluateReply}}</span></div>
                </li>
              </ul>
              <div class="viewAll" v-if="this.evaluatePageNumber < this.totalPage" @click="toMoreComment">查看更多评论<span class="el-icon-arrow-down"></span></div>
              <div class="viewAll" v-else>没有更多评论了<span class="el-icon-arrow-down"></span></div>
            </div>
              </div>
          <div class="contents" v-else v-html="page.memUnit"></div>
        </div>
      </div>
    </div>
    <homeFoots></homeFoots>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import banners from "@/components/comment/banners.vue";
import { fomateDateMount, fomateDate,fomateDate2 } from "@/util/util.js";
import totalComment from "@/components/comment/totalComment.vue";
import ImagePreviewList from "@/components/comment/ImagePreviewList.vue";
import axios from "axios";
export default {
  name: "leaderDetail",
  data() {
    return {
      pageNumber: 1,
      total: 0,
      nav: 0,
      navArray: ["TA的活动", "个人介绍","带队评分"],
      id:0,
      pageArray:[],
      page:[],
      evaluatePageNumber:1,
      pageSize:1,
      evaluateList:[],
      totalPage:0,
      evaluateTotal:0,
      evaluateTotalPage:0,
      loading:false,
      canLoadingMore:false,
      loading:false,
    };
  },
  components: {
    heads,
    homeFoots,
    banners,
    totalComment,
    ImagePreviewList
  },
  computed: {
    // nav() {
    //   return this.$route.params.id;
    // }
  },
  methods: {
    fomateDate,
    fomateDate2,
    getNav(index) {
      this.nav = index;
    },
    toDetail(id) {
      this.$router.push({
        path: "/activityDetail",
        query: { id:id }
      });
    },
   handleCurrentChange(val) {
      this.getMemberbyId();
    },
    handleSizeChange(val) {
    },
    toMoreComment() {
      if (this.loading) return;
      if (!this.canLoadingMore) return;
      this.canLoadingMore = false;
      this.evaluatePageNumber += 1;
      if (this.evaluatePageNumber > this.evaluateTotalPage) return;
      this.loading = true;
      try {
        this.getEvaluateList();
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    getMemberbyId() {
      axios
        .get(`mobile/member/getMemberbyId.jhtml`, {
          params: {
            id: this.id,
            pageNumber:this.pageNumber,
            pageSize: 10,
          }
        })
        .then(res => {
          if (res.data.success) {
            this.pageArray = res.data.returnValue.leaderList;
            this.page=res.data.returnValue.member
            this.total=res.data.returnValue.total;
          } else {
            this.$vux.toast.text("系统繁忙，请稍后再试~", "middle");
          }
          this.loading = false;
        });
    },
 // 获取数据
 getEvaluateList() {
      this.loading =true;
      axios
        .get(`/mobile/line_evaluate/leaderEvaluateList.jhtml`, {
          params: {
            pageNumber: this.evaluatePageNumber,
            pageSize: 10,
            leaderId:this.id
          },
        })
        .then((res) => {
          this.canLoadingMore = true;
          if (res.data.success) {
            let evaluateList = res.data.returnValue.content;
            if(evaluateList && evaluateList.length>0){
              // evaluateList.forEach(evaluate => {
              //   if(evaluate.image){
              //     evaluate.image = evaluate.image.split(",");
              //   }
              // });
              this.evaluateList = [...this.evaluateList, ...evaluateList];
            }
            this.evaluateTotalPage = res.data.returnValue.totalpage;
            this.evaluateTotal= res.data.returnValue.total;
            console.log("pageArray",this.pageArray)
            console.log("pageArray",this.pageArray)
          } else {
            this.$message(res.data.errorReason);
          }
          this.loading = false;
        });
    },
  },
  mounted() {},
  created() {
    if(this.$route.query.id){
      this.id = this.$route.query.id
      this.loading = true;
      this.getMemberbyId();
      this.getEvaluateList();
    }
  }
};
</script>

<style scoped>
.star-wrapper >>> .el-rate__icon{
        font-size: 28px;
        margin-left: 3px;
        margin-right: 3px;
    }
    .star-wrapper >>> .el-progress-bar__inner{
        font-size: 28px;
        margin-left: 3px;
        margin-right: 3px;
        background-color:'#FF7E00'
    }
.top-img {
  height: 400px;
}
.top-img > img{
  width: 100%;
  height: 100%;
}
.activityIndex {
  width: 100%;
  height: 100%;

  /* text-align: left; */
}
.container {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
}
.content {
  width: 100%;
  /* display: flex;
    flex-wrap: wrap;
    justify-content: space-between; */
  
  min-height: 300px;
}
.leaderlist {
  cursor: pointer;
  width: 100%;
  padding: 20px;
  /* box-shadow: 0px 0px 6px #c7c6c6;
      border-radius: 2px; */
  margin-bottom: 20px;
}
.leaderitem {
  display: flex;
  align-items: center;
}
.left-img {
  width: 80px;
  height: 80px;
  border-radius: 100%;
}
.right-info {
  height: 50px;
  line-height: 30px;
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid #999999;
}
.name {
  font-weight: bold;
  font-size: 17px;
}
.fa-mars {
  color: #0e79b1;
}
.fa-venus {
  color: #de4c4c;
}
.evaluate {
  display: flex;
}
.evaluate > span {
  font-size: 15px;
  width: 80px;
  color: #666666;
  line-height: 20px;
}
.evaluate > span:nth-child(2) {
  text-align: right;
  border-left: 1px solid #999999;
}
.textnav {
  display: flex;
  width: 100%;
  justify-content: space-around;
  height: 40px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
  margin-top: 30px;
  padding: 0 300px;
  box-sizing: border-box;
}
.textnav > .textnav-item,
.textnav > a {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}
.textnav > .textnav-item{
  position: relative;
}
.textnav > .textnav-item > .total
{
  position: absolute;
        left: 90%;
        top: 0px;
        height: 16px;
        line-height: 16px;
        font-size: 14px;
        border-radius: 14px;
        padding: 0 10px;
        background-color: #ff5000;
        color: #fff;
}
.nac-active {
  color: #007741;
  font-weight: bold;
  border-bottom: 2px solid #007741;
}
.useractivity {
  width: 100%;
}
.useritem {
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0px 0px 6px #c7c6c6;
  margin-bottom: 16px;
}
.img {
  position: relative;
  width: 24%;
  height: 180px;
}
.act-img {
  width: 100%;
  height: 100%;
}
.user-price {
  position: absolute;
  z-index: 30;
  bottom: 14px;
  right: 16px;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
  font-size: 14px;
  padding: 4px 12px;
}
.user-right {
  width: 76%;
  position: relative;
  padding: 20px;
  box-sizing: border-box;
}
.act-title {
  font-weight: bold;
}
.userdescribe {
  margin-top: 20px;
  line-height: 24px;
  color: #999999;
}
.bottom-infos {
  width: 90%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 10px;
}
.icon-one {
  color: #b0b0b0;
  margin-right: 10px;
}
.icon-two {
  color: #b0b0b0;
}
.mores {
  color: #007940;
}
</style>
<style lang="scss"  scoped>
 .evaluate-list{
              min-height:400px;
              .art-title{
                color:#007741;
                margin-top: 10px;
              }
              .viewAll{
                width:100%;
                text-align:center;
                margin-top:20px;
              }

              ul{
                  .evaluate-item{
                                        
                    padding: 4px 0;
            position: relative;
            display: flex;
            flex-direction: column;
            width: 100%;
                    .evaluate-main{
                    
                    padding: 4px 0;
            position: relative;
            display: flex;
            width: 100%;
            .left{
              flex: 2;
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 150px;
              .avatar{
                width: 140px;
                margin-right: 12px;
                margin:0 5px 5px;
                text-align: center;
                img{
                  width: 100px;
                  height: 100px;
                  border-radius: 50%;
                  vertical-align: top;
                }
              }
              .name {
                width: 120px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                overflow: hidden;
                display: inline-block;
                line-height: 18px;
                height: 18px;
                padding: 0 0px;
                box-sizing: border-box;
                font-size: 16px;
                color: #999;
                text-align: center;
              }
            } 
            .right{
              flex: 9;
              .text{
                line-height: 20px;
                font-size: 16px;
                color: #333;
                padding-left: 10px;
                margin-bottom: 8px;
                text-align: left;
              } 
              .star-wrapper{
                width: 300px;
                height: 24px;
                padding-left: 8px;
                margin-bottom: 6px;
                position: relative;
                padding-left: 8px;
                top: 0px;
                left: -7px;
                display: inline-block;
                font-size: 0;
                vertical-align: top;
              } 
              .comment-images-out{
                 overflow-x: auto;
                 padding-left:10px;
                  .comment-images{
                   display: flex;
                   flex-direction: row;
                   flex-wrap: wrap;
                   img{
                     margin: 10px 10px 10px 0;
                     width: 70px;
                     height: 70px;
                     border-radius: 16px;
                   }
                  }
                }
                .bottom-line{
                color:#999;
                font-size:14px;
                padding-left: 10px;
                .time{
                  margin-right:5px;
                }
                .leader{

                }
              }
              }

                  }
                  .seller-reply{
                    font-size:28px;
                    padding: 15px;
                    margin-top: 10px;
                    background: #F6F6F6;
                    font-size: 16px;
                    color:#ff7e00;
                    .main{
                      color:#333;
                      
                    }
                  }


        }
      }
    }    
</style>



// WEBPACK FOOTER //
// src/components/leaderview/leaderDetail.vue